<template>
  <layout-basic>
    <section class="banner-text padding-bottom">
      <v-row no-gutters>
        <v-col class="banner-wrapper">
          <!-- Shape Background -->
          <div class="shape-background">
            <img
              class="background-image border-bottom"
              :src="
                getImageSource(
                  'improve-main-banner-gradient-background.png',
                  'homepage/banner'
                )
              "
            />

            <img
              class="banner-green-image"
              :src="
                getImageSource(
                  'improve-main-banner-green-shape.png',
                  'homepage/banner'
                )
              "
            />
            <img
              class="banner-grey-image"
              :src="
                getImageSource(
                  'improve-main-banner-grey-shape.png',
                  'homepage/banner'
                )
              "
            />
            <img
              class="banner-orange-image"
              :src="
                getImageSource(
                  'improve-main-banner-light-blue-rectangle.png',
                  'homepage/banner'
                )
              "
            />
          </div>
          <v-container class="banner-img-text-wrapper">
            <!-- Banner Left Wrapper -->
            <div class="banner-left-wrapper">
              <div id="main-banner-wrapper">
                <img
                  class="rounded-rectangle-image"
                  :src="
                    getImageSource(
                      'main-banner-rounded-rectangle.png',
                      'homepage/banner'
                    )
                  "
                />
                <div class="banner-text-overlay">
                  COMPLETE TRAINING SOLUTION
                </div>
              </div>
              <div class="banner-main-title">
                How does your Business Handle Employee Training?
              </div>
              <div class="banner-sub-text">
                IMPROVE assists your business in upskilling your staff,
                onboarding new starters, and managing compliance throughout your
                organisation with off-the-shelf training courses.
              </div>
              <div class="d-flex flex-sm-column-custom">
                <a
                  id="request-demo-btn"
                  href="/contact"
                  class="request-demo-btn mt-8 d-flex align-self-center mx-2"
                >
                  Request a Demo
                </a>
                <a 
                  id="course-library-header-btn"
                  href="/course-library"
                  class="course-library-header-btn mt-8 d-flex align-self-center mx-2"
                >
                  Course Library
                </a>
              </div>
            </div>

            <!-- Microlearning Image -->
            <img
              class="microlearning-image"
              :src="
                getImageSource(
                  'improve-microlearning-platform-for-your-business.png',
                  'homepage/banner'
                )
              "
            />
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section class="improve-customers">
      <v-row no-gutters class="text-center mt-10">
        <v-container style="padding: 0 25px">
          <div class="carousel-title">
            Organisations across multiple sectors using IMPROVE
          </div>
          <v-col class="pa-0" cols="12" md="12" p>
            <VueSlickCarousel v-bind="imageCarousel">
              <template #prevArrow="arrowOption">
                <div class="custom-carousel-button">
                  <span><i class="fa fa-chevron-left"></i></span>
                </div>
              </template>
              <template #nextArrow="arrowOption">
                <div class="custom-carousel-button">
                  <span><i class="fa fa-chevron-right"></i></span>
                </div>
              </template>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/advoacy-focus.png"
                  class="img-fluid"
                  alt="Advocacy Focus Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/east-midlands-chamber.png"
                  class="img-fluid"
                  alt="East Midlands Chamber Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/eden-holistic-pet-foods.png"
                  class="img-fluid"
                  alt="Eden Holistic Pet Foods Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/effectech.png"
                  class="img-fluid"
                  alt="Effectech Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/hr-central-human-resources-consultancy.jpg"
                  class="img-fluid"
                  alt="HR Central Human Resources Consultancy Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/hope-nottingham.png"
                  class="img-fluid"
                  alt="Hope Nottingham Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/la-micro.png"
                  class="img-fluid"
                  alt="La Micro Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/laceys-solicitors.png"
                  class="img-fluid"
                  alt="Laceys Solicitors Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/m-j-r.png"
                  class="img-fluid"
                  alt="M J R Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/people-value.png"
                  class="img-fluid"
                  alt="People Value Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/pilkington.png"
                  class="img-fluid"
                  alt="Pilkington Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/tevva.png"
                  class="img-fluid"
                  alt="Tevva Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/APK_Group_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="APK Group Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/3SC_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="3SC Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Advonet_Group_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Advonet Group Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Boostwork_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Boostwork Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/BPX_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="BPX Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Carter_IMPROVE_Customer.png"
                  class="img-fluid"
                  alt="Carter Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/China-Britain-Business-Council-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="China Britain Business Council Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Council-of-Deans-of-Heath-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="Council of Deans of Health Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/Devon-Community-Foundation-IMPROVE-Customer.jpg"
                  class="img-fluid"
                  alt="Devon Community Foundation Approved IMPROVE partner"
                />
              </div>
              <div class="customers-item">
                <img
                  src="/static/homepage/carousel/IP-Group-IMPROVE-Customer.png"
                  class="img-fluid"
                  alt="IP Group Approved IMPROVE partner"
                />
              </div>
            </VueSlickCarousel>
          </v-col>
        </v-container>
      </v-row>
    </section>
    <hr />
    <section style="margin-bottom: 40px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container>
            <div class="benefit-title text-center">
              <h2>The Complete Microlearning Solution For Your Business</h2>

              <span>Tailored training courses that don't cost the earth. </span>

              <p>
                With an ever-growing course library, IMPROVE enables you to
                enhance the skills of your staff and seamlessly onboard new
                employees in your organisation. Upload courses, add policies and
                procedures that are unique to your business
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" md="12">
          <v-container v-if="screenSize === 'mobile'" style="padding: 0 25px">
              <img
                class="w-100"
                src="/static/homepage/benefits/mobile-benefits.png"
              />
          </v-container>
          <v-container
            v-else
            class="animate-on-scroll"
            :class="{ animate: inViewport }"
          >
            <div class="benefit-container">
              <img
                src="/static/homepage/benefits/benefits-of-improves-microlearning-platform.png"
                class="benefit-human-image"
              />
              <div class="benefit-wrapper">
                <div id="benefit-training">
                  <img
                    style="width: 100%;max-width: 432px;"
                    src="/static/homepage/benefits/improve-benefits-rounded-rectangle-background.png"
                  />
                  <img
                    class="benefit-training-icon"
                    src="/static/homepage/benefits/tailored-business-training-with-improve.png"
                  />
                  <div class="benefit-training-text">
                    <h3>Tailored Training</h3>
                    <p>
                      Add your own documents
                    </p>
                  </div>
                </div>

                <div id="benefit-support">
                  <img
                    style="width: 100%;max-width: 432px;"
                    src="/static/homepage/benefits/improve-benefits-rounded-rectangle-background.png"
                  />
                  <img
                    class="benefit-support-icon"
                    src="/static/homepage/benefits/improve-scalable-platform-for-businesses.png"
                  />
                  <div class="benefit-support-text">
                    <h3>Add Your Own Documents</h3>
                    <p>
                      Content relevant to your business
                    </p>
                  </div>
                </div>

                <div id="benefit-starters">
                  <img
                    style="width: 100%;max-width: 432px;"
                    src="/static/homepage/benefits/improve-benefits-rounded-rectangle-background.png"
                  />
                  <img
                    class="benefit-starters-icon"
                    src="/static/homepage/benefits/induct-new-starters-with-improve.png"
                  />
                  <div class="benefit-starters-text">
                    <h3>Induct New Starters</h3>
                    <p>
                      Seamless integration for new staff
                    </p>
                  </div>
                </div>

                <div id="benefit-platform">
                  <img
                    style="width: 100%;max-width: 432px;"
                    src="/static/homepage/benefits/improve-benefits-rounded-rectangle-background.png"
                  />
                  <img
                    class="benefit-platform-icon"
                    src="/static/homepage/benefits/improve-dedicated-support-for-businesses.png"
                  />
                  <div class="benefit-platform-text">
                    <h3>Dedicated Support</h3>
                    <p>
                      Knowledgeable and friendly team
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>
    <hr />
    <section style="margin-bottom: 80px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container>
            <div class="testimonial-title text-center">
              <img
                src="/static/homepage/testimonial/improve-customer-testimonials.png"
              />

              <h2>Customer Testimonials</h2>

              <p>
                What our customers say about IMPROVE
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container>
        <VueSlickCarousel v-bind="testimonialCarousel">
          <div class="testimonial-item">
            <div class="testimonial-card">
              <div>
                <h2>“Flexible and Limitless”</h2>
                <p>
                  “The system is like no other in the market. HRCentral Limited 
                  and our clients are continually impressed by the user-friendly, 
                  flexible and limitless training opportunities IMPROVE can offer.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“The Best Onboarding Process”</h2>
                <p>
                  “New staff have been in ‘awe’ of our onboarding process which
                  is all centrally delivered via IMPROVE. We have found it to be
                  the best onboarding process we have experienced.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/advocacy-focus-testimonial.png"
                alt="Advocacy Focus Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Comprehensive & Easy to Access”</h2>
                <p>
                  “It’s authoritative, accurate, comprehensive, and easy to
                  access. It removes the stress of training delivery from
                  business owners, knowing that they can review what their staff
                  are learning.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/smart-space-testimonial.png"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <div class="testimonial-card">
              <div>
                <h2>“Consistently Impressed”</h2>
                <p>
                  “As a proud partner of IMPROVE, we have been consistently impressed with the 
                  customer service and support we have received from the team. They are responsive, 
                  go out of their way to help, and adapt to support our needs and growth as a HR 
                  consultancy, which in turn supports our clients.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Seamless Training Process”</h2>
                <p>
                  “The user-friendly interface has been built to ensure that
                  everyone can use it with ease, and the courses are tailored to
                  suit each team member's learning needs.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/eden-holistic-pet-foods-testimonial.png"
                alt="Eden Holistic Pet Foods Approved IMPROVE partner"
              />
            </div>
          </div>
        </VueSlickCarousel>
      </v-container>
    </section>
    <hr />
    <section>
      <v-row no-gutters>
        <v-col cols="12" align-self="center" no-gutters>
          <v-container style="padding: 0 15px;">
            <img
              class="compliance-img-overlay"
              :src="
                getImageSource(
                  'improve-compliance-management-shape.png',
                  'homepage/compliance'
                )
              "
            />

            <div class="compliance-wrapper">
              <div class="compliance-content">
                <h1>Compliance Training Courses</h1>

                <span>Essential compliance training for your business. </span>

                <p>
                  <b>Monitor</b> and <b>manage</b> your
                  <b>compliance-focused training,</b> encompassing areas such as
                  <b>policies</b> and <b>procedures</b>. Craft
                  <b>curated playlists</b>
                  tailored to your
                  <b>organisation's compliance requirements,</b> and
                  <b>maintain training records</b> with ease.
                </p>
                <a href="/course-library" class="course-library-btn">
                  Course Library
                </a>
              </div>
              <img
                class="compliance-image"
                :src="
                  getImageSource(
                    'compliance-management-courses-and-training-for-staff.png',
                    'homepage/compliance'
                  )
                "
              />
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section style="position: relative;">
      <img
        class="induct-img-overlay"
        :src="
          getImageSource(
            'improve-grey-rounded-rectangle.png',
            'homepage/induct'
          )
        "
      />
      <v-row no-gutters>
        <v-col cols="12" align-self="center" no-gutters>
          <v-container style="padding: 0 15px;">
            <div class="induct-wrapper">
              <img
                class="induct-image pe-md-5"
                :src="
                  getImageSource(
                    'induct-new-starters-with-improve.png',
                    'homepage/induct'
                  )
                "
              />
              <div class="induct-content ps-md-5">
                <h1>Easily Induct New Starters</h1>

                <span>Simplify your business’s onboarding process.</span>

                <p>
                  With <b>IMPROVE</b> you can upload
                  <b>your induction documents, create courses</b> and
                  <b>playlists.</b> Empower <b>new starters</b> with the
                  <b>knowledge</b> and <b>skills</b> they need to accelerate their
                  <b>integration</b> and hit the ground running from day one.
                </p>
                <a
                  :href="directUrl + '/#/signup?ref=website'"
                  class="induct-btn"
                >
                  Free Trial
                </a>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>
    <hr />
    <section style="margin: 80px 0;">
            <v-row no-gutters>
                <v-col cols="12" align-self="center">
                    <v-container>
                        <div class="hr-integration-title text-center">
                            <h2>Seamless Integration</h2>
                            <span>
Synchronise users from HR applications directly and streamline user management.
                            </span>
                            <p>
Directly import staff data into IMPROVE and simplify your onboarding process.</p>
                        </div>
                        <v-col cols="12" md="12" p>
                            <div class="logo-grid">
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-sense-hr.png" alt="Sense HR">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-breathe-hr.png" alt="Breathe">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-sage-hr.png" alt="Sage">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-people-hr.png" alt="People">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-bamboohr-integration.png" alt="Bamboohr">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-iris.png" alt="Iris">
                                </div>
                            </div>
                            <a href="/hr-integrations" class="integration-btn">
                              Learn More
                            </a>
                        </v-col>
                    </v-container>
                </v-col>
            </v-row>
        </section>    
        <hr />
    <section>
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container style="padding: 0 15px;">
            <img
              class="upskill-img-overlay"
              :src="
                getImageSource(
                  'improve-green-rounded-rectangle.png',
                  'homepage/upskill'
                )
              "
            />

            <div class="upskill-wrapper">
              <div class="upskill-content">
                <h1>Keep your Staff Compliant</h1>

                <span>Off-the-shelf training courses for staff.</span>

                <p>
                  Equip your <b>employees</b> with the <b>knowledge</b> and
                  <b>skills</b> they need to excel in their roles with
                  off-the-shelf <b>training courses. IMPROVE</b> automatically
                  awards <b>certificates</b> upon completion of every course
                  completed.
                </p>
                <a href="/features" class="course-library-btn">
                  Explore Features
                </a>
              </div>
              <img
                class="upskill-image"
                :src="
                  getImageSource(
                    'training-courses-from-improve.png',
                    'homepage/upskill'
                  )
                "
              />
            </div>
          </v-container>
        </v-col>
      </v-row>
    </section>
    <section>
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container style="padding: 0 15px;">
            <div class="testimonial-title text-center">
              <img
                src="/static/homepage/choose/why-choose-improve-for-your-business.png"
              />

              <h2>Why Choose IMPROVE?</h2>

              <p>
                How IMPROVE can benefit your business
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container class="choose-cards">
        <v-row class="choose-cards">
          <v-col cols="12" sm="12" md="4">
            <div class="training-card">
              <img
                src="/static/homepage/choose/tailored-training-with-improve.png"
              />
              <h2>Tailored Training</h2>
              <p>
                Add your own documents to courses to align with your industry,
                processes, and company values, ensuring training is relevant.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>
          <v-col cols="12" sm="12" md="4">
            <div class="scalable-card">
              <img
                src="/static/homepage/choose/improve-scalable-platform.png"
              />
              <h2>Upload Courses</h2>
              <p>
                Easily upload and publish your own courses within IMPROVE to
                ensure staff training is relevant to your business.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>
          <v-col cols="12" sm="12" md="4">
            <div class="dedicated-card">
              <img
                src="/static/homepage/choose/improve-offering-dedicated-support.png"
              />
              <h2>Dedicated Support</h2>
              <p>
                Our customer support team is dedicated to ensuring your
                experience is hassle-free. From implementation to ongoing
                support.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="courses-card">
              <img
                src="/static/homepage/choose/access-courses-24-7-with-improve.png"
              />
              <h2>24/7 Course Access</h2>
              <p>
                Learn at your own pace; IMPROVE can be accessed from any device,
                enabling your team to learn at a time that suits them.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="cost-card">
              <img
                src="/static/homepage/choose/save-time-and-money-with-improve.png"
              />
              <h2>Time and Cost Savings</h2>
              <p>
                Streamline your training and compliance processes with IMPROVE’s
                automated features, saving valuable time and resources for your
                organisation.
              </p>
            </div>
          </v-col>
          <div class="choose-card-bottom"></div>

          <v-col cols="12" sm="12" md="4">
            <div class="platform-card">
              <img
                src="/static/homepage/choose/one-training-platform-for-your-business.png"
              />
              <h2>One Solution</h2>
              <p>
                Keep your training materials in one, easy to use solution. Group
                staff by roles and responsibilities and assign relevant training
                materials and courses.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="animate-cat-on-scroll">
      <v-row no-gutters>
        <v-col no-gutters>
          <!-- Shape Background -->
          <div class="demo-background">
            <img
              class="demo-background-image"
              :src="
                getImageSource(
                  'improve-demo-section-background.png',
                  'homepage/demo'
                )
              "
            />
            <img
              class="demo-background-right-shape"
              :src="
                getImageSource(
                  'improve-demo-section-rounded-rectangle.png',
                  'homepage/demo'
                )
              "
            />
            <img
              class="demo-background-left-shape"
              :src="
                getImageSource(
                  'improve-demo-section-shape.png',
                  'homepage/demo'
                )
              "
            />
            <img
              class="demo-background-cat"
              :src="
                getImageSource(
                  'training-courses-for-smes-with-improve.png',
                  'homepage/demo'
                )
              "
            />
            <div class="demo-content">
              <h2>Book a Demonstration</h2>
              <p>
                Experience the power of IMPROVE, the microlearning solution
                designed to enhance training in your business.
              </p>
              <a href="/contact" class="book-demo-btn">
                Request a Demo
              </a>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { screensize } from '../../utils/screensize';
import { IMPROVE_CONFIG } from '@/config.js';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'Homepage',
  metaInfo() {
      return {
          title: "IMPROVE: UK's Leading LMS for SMEs | Simple, Scalable, Cost-Effective",
          meta: [
              // Meta Description
              { name: 'description', content: "Enhance staff training with IMPROVE, the UK's #1 simple, scalable, and cost-effective LMS for SMEs. Tailored training, onboarding solutions, and compliance management. Start your FREE 14-day trial today!" },
              
              // Meta Keywords
              { name: 'keywords', content: "LMS, LMS UK, Learn LMS, #1 LMS Software, LMS onboard & upskill, LMS for SMEs, Onboarding training modules, Onboarding, Learning Management System (LMS), Best LMS software, Cloud-based LMS, LMS for businesses, LMS for education, Corporate LMS platform, LMS software comparison, LMS for corporate training, Online training platform, LMS for employee training, LMS for onboarding, LMS with certifications, LMS with SCORM support, LMS with SSO (Single Sign-On), LMS with Google & Microsoft authentication, LMS with custom branding, Mobile-friendly LMS, Affordable LMS for small businesses, LMS with easy setup, LMS with automation features, LMS with analytics and reporting, Best LMS for small businesses in 2025, LMS free trial, Best LMS software for compliance training, SCORM-compliant LMS free trial, Top LMS for online courses, LMS software in the UK / US, Online training software, online training platform, staff training solutions, employee onboarding, compliance management, microlearning courses, cost-effective training, scalable learning platform, IMPROVE LMS" },
              
              // Open Graph / Facebook Tags
              { property: 'og:title', content: "IMPROVE: UK's Leading LMS for SMEs | Simple, Scalable, Cost-Effective" },
              { property: 'og:description', content: "Discover IMPROVE, the ultimate LMS for SMEs. Streamline staff training, onboarding, and compliance with scalable, tailored microlearning solutions. Request a demo now!" },
              { property: 'og:image', content: "https://www.improve.online/static/seo.png" },
              { property: 'og:type', content: "website" },
              { property: 'og:url', content: "https://www.improve.online/" },
              
              // Twitter Tags
              { name: 'twitter:card', content: "summary_large_image" },
              { name: 'twitter:title', content: "IMPROVE: UK's Leading LMS for SMEs | Simple, Scalable, Cost-Effective" },
              { name: 'twitter:description', content: "Boost your team's skills with IMPROVE: the UK's #1 LMS for SMEs. Affordable microlearning, compliance management, and tailored training solutions. Start today!" },
              { name: 'twitter:image', content: "https://www.improve.online/static/seo.png" }
          ],
          link: [
              // Canonical URL
              { rel: 'canonical', href: "https://www.improve.online/" }
          ]
      };
  },
  components: {
    LayoutBasic,
    VueSlickCarousel,
  },
  data() {
    return {
      inViewport: false,
      screenSize: currentScreenSize,
      imageCarousel: {
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      testimonialCarousel: {
        infinite: true,
        autoplay: true,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      directUrl: IMPROVE_CONFIG.DIRECT_URL,
    };
  },
  mounted() {
    let referralID = window.location.search;
    if (referralID != '') {
      let getRefID = referralID.split('?');
      localStorage.setItem('refID', getRefID[1]);
      window.location.href = 'https://www.improve.online';
    }
    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);

    // Listen for scroll events
    window.addEventListener('scroll', this.handleScroll);
    // Initial check when the component mounts
    this.handleScroll();
  },
  methods: {
    // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    // Method to dynamically generate the image source based on screen size
    getImageSource(imageName, filepath) {
      return `/static/${filepath}/${this.screenSize}/${imageName}`;
    },

    handleScroll() {
      const element = this.$el.querySelector('.animate-on-scroll');
      const catElemet = this.$el.querySelector('.animate-cat-on-scroll');

      const rect = element.getBoundingClientRect();
      const inViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      // Update the data property
      this.inViewport = inViewport;

      const catRect = catElemet.getBoundingClientRect();
      const catInViewport =
        catRect.top >= 0 &&
        catRect.left >= 0 &&
        catRect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        catRect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      if (catInViewport) {
        catElemet.classList.add('animate');
      }
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
    // Clean up: Remove event listener
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
